// WP-07 — TokenStore (LLD-05 §4/§11): the ApiClient's only view of the JWT
// pair. Backed by the persisted SessionStore so a reload survives, but the
// ApiClient never touches user/role state through it.
import type { Tokens } from "./contracts";
import { sessionStore } from "../auth/session-store";

export class TokenStore {
  get(): Tokens | null {
    return sessionStore.getState().tokens;
  }

  set(tokens: Tokens): void {
    sessionStore.getState().setTokens(tokens);
  }

  clear(): void {
    sessionStore.getState().clearSession();
  }

  isExpired(now: number = Date.now()): boolean {
    const tokens = this.get();
    return tokens === null || tokens.expiresAt <= now;
  }
}

export function toTokens(dto: {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}): Tokens {
  return {
    accessToken: dto.accessToken,
    refreshToken: dto.refreshToken,
    expiresAt: Date.now() + dto.expiresIn * 1000,
  };
}
